import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useAddProject = () => {
  const queryClient = useQueryClient();

  const { mutate, isLoading } = useMutation(async (projectData) => {
    const newProject = await axios.post('/projects/create', projectData);
    return newProject;
  });

  const addProject = (formData, { onSuccess }) => {
    mutate(formData, {
      onSuccess: (res) => {
        queryClient.invalidateQueries('projects', { exact: true });
        toast.success(`The new project ${res.data.name} is successfully created`);
        onSuccess && onSuccess(res.data);
      },
      onError: (res) => {
        toast.error(res.message);
      },
    });
  };

  return {
    addProject,
    isLoading,
  };
};

export default useAddProject;
